import ERRORS from './errorids';
import { XC_URL, CB_LIBRARY_SUPPORT_ARTICLE_EN, CB_LIBRARY_SUPPORT_ARTICLE_DE } from 'config';
import { SUBSCRIPTION } from 'routes';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const RELOAD_URL = '/?reload-app=true';

const DEFAULT_BUTTONS = {
	CLOSE: {
		label: localize('close'),
		close: true,
		autoFocus: true,
		primary: false
	},
	CLOSE_REDIRECT: {
		label: localize('close'),
		close: true,
		autoFocus: true,
		redirect: XC_URL,
		primary: false
	},
	UPGRADE: {
		label: localize('upgrade'),
		close: true,
		autoFocus: true,
		redirect: SUBSCRIPTION,
		primary: true
	},
	OK: {
		label: localize('ok'),
		close: true,
		autoFocus: true,
		primary: false
	},
	RELOAD: {
		label: localize('error-messages-button-reload'),
		close: true,
		autoFocus: true,
		redirect: RELOAD_URL,
		primary: false
	}
};

const ERROR_MESSAGES = {

	UNHANDLED_ERROR: errorId => {
		return {
			message: localize('error-message-unhandled', errorId),
			buttons: [DEFAULT_BUTTONS.RELOAD]
		};
	},

	[ERRORS.SEGMENT_NOT_LOADED]: {
		message: localize('subscriptions-error-segment-disabled'),
		buttons: [DEFAULT_BUTTONS.CLOSE]
	},

	[ERRORS.OFFLINE]: {
		message: localize('error-message-offline'),
		buttons: [DEFAULT_BUTTONS.RELOAD]
	},

	[ERRORS.XHR_FAILED]: {
		message: localize('error-message-xhr-failed'),
		buttons: [DEFAULT_BUTTONS.RELOAD]
	},

	[ERRORS.INVALID_COMPANY_ID_OR_COMPANY_NAME]: {
		message: localize('error-message-invalid-company-id-or-company-name'),
		buttons: [DEFAULT_BUTTONS.CLOSE]
	},

	[ERRORS.INSUFFICIENT_USER_RIGHTS]: {
		message: localize('error-message-insufficient-rights'),
		buttons: [DEFAULT_BUTTONS.CLOSE]
	},

	[ERRORS.COMPANY_NOT_FOUND]: {
		message: localize('error-message-company-not-found'),
		buttons: [DEFAULT_BUTTONS.CLOSE]
	},

	[ERRORS.USER_NOT_VALIDATED]: {
		message: localize('error-message-user-not-validated'),
		buttons: [
			{
				label: localize('error-user-not-validated-resend-button')
			},
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.DELETE_MYSELF]: {
		message: localize('error-message-delete-myself'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.INVALID_PHONE_NUMBER]: {
		message: localize('error-message-invalid-phone-number'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.INVALID_WEBSITE_URL]: {
		message: localize('error-message-invalid-website-url'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.INVALID_COMPANY_COUNTRY]: {
		message: localize('error-message-.invalid-company-country'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.INVALID_COMPANY_INDUSTRY]: {
		message: localize('error-message-invalid-company-industry'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.INVALID_COMPANY_SIZE]: {
		message: localize('error-message-invalid-company-size'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.FAILED_TO_CREATE_COMPANY_SUBSCRIPTION]: {
		message: localize('error-message-failed-to-create-company-subscription'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.NO_ACTIVE_SUBSCRIPTION]: {
		message: localize('error-message-no-active-subscription'),
		buttons: [
			DEFAULT_BUTTONS.UPGRADE
		]
	},

	[ERRORS.INVALID_CLOUD_DRIVE_ADDED]: {
		message: localize('error-message-invalid-cloud-drive-added'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.PAYMENT_PROCESSING_FAILED]: {
		message: localize('error-message-payment-processing-failed'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.PAYMENT_METHOD_VERIFICATION_FAILED]: {
		message: localize('error-message-payment-method-verification-failed'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.PAYMENT_METHOD_NOT_PRESENT]: {
		message: localize('error-message-payment-method-not-present'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.PAYMENT_GATEWAY_CURRENCY_INCOMPATIBLE]: {
		message: localize('error-message-payment-gateway-currency-incompatible'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.PAYMENT_PROVIDER_INTERNAL_ERROR]: {
		// eslint-disable-next-line max-len
		message: localize('error-message-payment-provider-internal-error'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.PAYMENT_PROVIDER_INTERNAL_COUPON_ERROR]: {
		// eslint-disable-next-line max-len
		message: localize('error-message-payment-provider-internal-coupon-error'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.WRONG_FONT_TYPE_UPLOADED]: {
		message: localize('error-message-wrong-font-type-uploaded'),
		buttons: [
			DEFAULT_BUTTONS.OK
		]
	},

	[ERRORS.CHECKSUM_CONFLICT_INVALID_FONT_FILE]: {
		message: localize('error-message-checksum-conflict-invalid-font-file'),
		buttons: [
			DEFAULT_BUTTONS.OK
		]
	},

	[ERRORS.WORKSPACE_NAME_ALREADY_EXISTS]: {
		message: localize('error-message-workspace-name-already-exists'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.CLOUD_STORAGE_ITEM_NOT_FOLDER]: {
		message: localize('error-message-cloud-storage-item-not-folder'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.CLOUD_STORAGE_FOLDER_NOT_WRITABLE]: {
		message: localize('error-message-cloud-storage-folder-not-writable'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.COMPANY_NAME_ALREADY_EXISTS]: {
		message: localize('error-message-company-name-already-exists'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.INVALID_COMPANY_NAME]: {
		message: localize('error-message-invalid-company-name'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.INVALID_EMAIL]: {
		message: localize('error-message-invalid-email'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.INVALID_WORKSPACE_NAME]: {
		message: localize('error-message-invalid-workspace-name'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.SUBSCRIPTION_PLAN_CURRENCY_MISMATCH]: {
		message: localize('error-message-subscription-plan-currency-mismatch'),
		buttons: [
			Object.assign({}, DEFAULT_BUTTONS.OK, { redirect: SUBSCRIPTION })
		]
	},

	[ERRORS.COMPANY_ALREADY_EXISTS]: {
		message: localize('error-message-company-already-exists'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.USER_ALREADY_EXISTS_IN_COMPANY]: {
		message: localize('error-message-user-already-exists-in-company'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.DOMAIN_ALREADY_EXISTS_IN_COMPANY]: {
		message: localize('error-message-domain-already-exists-in-company'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.FOLDER_ALREADY_EXISTS_IN_COMPANY]: {
		message: localize('error-message-folder-already-exists-in-company'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.SMART_FIELD_ALREADY_EXISTS_IN_COMPANY]: {
		message: localize('error-message-smart-field-already-exists-in-company'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.WORKSPACE_ALREADY_EXISTS_IN_COMPANY]: {
		message: localize('error-message-workspace-already-exists-in-company'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.USER_ALREADY_EXISTS_IN_WORKSPACE]: {
		message: localize('error-message-user-already-exists-in-workspace'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.DOMAIN_ALREADY_EXISTS_IN_WORKSPACE]: {
		message: localize('error-message-domain-already-exists-in-workspace'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.WAITING_FOR_API]: {
		// eslint-disable-next-line max-len
		message: localize('error-message-waiting-for-api'),
	},

	[ERRORS.CB_NOT_LOADED]: {
		message: localize(
			'error-message-cb-not-loaded',
			i18n.getCurrentLanguage() === 'de' ? CB_LIBRARY_SUPPORT_ARTICLE_DE : CB_LIBRARY_SUPPORT_ARTICLE_EN
		),
		buttons: [DEFAULT_BUTTONS.RELOAD]
	},
	
	[ERRORS.FAILED_TO_GET_PAYMENT_COUPON]: {
		message: localize('error-message-failed-to-get-payment-coupon'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},
	
	[ERRORS.INVALID_COUPON_SET_ID]: {
		message: localize('error-message-invalid-coupon-set-id'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},
	
	[ERRORS.INVALID_COUPON_ID]: {
		message: localize('error-message-invalid-coupon-id'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},	

	[ERRORS.FAILED_TO_CREATE_COMPANY_ADDON]: {
		message: localize('error-message-failed-to-create-order-in-payment-gateway'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},	
	
	[ERRORS.FAILED_TO_TRIGGER_PAYMENT_FLOW]: {
		message: localize('error-message-failed-to-create-order-in-payment-gateway'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},	
	
	[ERRORS.COUPON_CODE_ALREADY_EXISTS]: {
		message: localize('error-message-duplicate-coupon-id'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY]: {
		message: localize('error-message-invalid-number-of-users-during-checkout'),
		buttons: [
			DEFAULT_BUTTONS.CLOSE
		]
	},

	[ERRORS.API_REQUEST_LIMIT_EXCEEDED]: {
		message: localize('error-cb-api-rate-limit-reached'),
		buttons: [DEFAULT_BUTTONS.RELOAD]
	},

	[ERRORS.USER_REACHED_THE_COMPANY_INVITATION_LIMIT]: {
		message: localize('error-number-of-users-on-non-paying-account-exceeded'),
		buttons: [DEFAULT_BUTTONS.UPGRADE, DEFAULT_BUTTONS.CLOSE]
	}
};

export default ERROR_MESSAGES;


// WEBPACK FOOTER //
// ./src/errors/errormessages.js